import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private cookieService: CookieService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Initialize headers with defaults

    const headersConfig: Record<string, string> = {
      Accept: 'application/json',
    };

    const accessToken = this.cookieService.get('accessToken');
    const idToken = this.cookieService.get('idToken');
    const refreshToken = this.cookieService.get('refreshToken');

    if (idToken) headersConfig['id-token'] = idToken;
    if (accessToken) headersConfig['access-token'] = accessToken;
    if (refreshToken) headersConfig['refresh-token'] = refreshToken;

    // Clone and modify the request with new headers
    const modifiedReq = request.clone({
      headers: new HttpHeaders(headersConfig),
    });

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('HTTP Error Occurred:', error);
        // Optionally rethrow the error or handle it as needed
        return throwError(() => error);
      })
    );
  }
}
